import { useEffect, useMemo, useRef } from 'react'
import { connect } from 'react-redux'
import {
  STATIC_NAV_ENTRIES,
  buildDynamicNavigationEntries,
  buildNavigationMiniSearchIndex,
  searchNavigationMiniSearch,
} from '../local/navigationRegistry'

/**
 * Runs the navigation registry through a MiniSearch (BM25) index and routes
 * results to SupplementarySearchContext under providerId='navigation-minisearch'.
 *
 * This is the only engine behind the navigation rows — it presents to users and
 * feeds the non-content section of the search-quality report.
 */
function NavigationMiniSearchProvider({
  query, options, onResults,
  sections,
}) {
  const entries = useMemo(
    () => STATIC_NAV_ENTRIES.concat(
      buildDynamicNavigationEntries({ sections }),
    ),
    [sections],
  )

  const ms = useMemo(() => buildNavigationMiniSearchIndex(entries), [entries])

  const onResultsRef = useRef(onResults)
  onResultsRef.current = onResults

  useEffect(() => {
    if (!query) {
      onResultsRef.current({ hits: [] })
      return
    }
    const limit = options && options.hitsPerPage ? options.hitsPerPage : 8
    const hits = searchNavigationMiniSearch(ms, entries, query, limit)
    onResultsRef.current({ hits })
  }, [query, ms, entries, options])

  return null
}

function mapStateToProps(state) {
  return {
    sections: state.sections,
  }
}

export default connect(mapStateToProps)(NavigationMiniSearchProvider)
